var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-status"},[(_vm.v.$invalid)?_c('span',{staticClass:"fa fa-check-circle fa-3x text-danger"}):_c('span',{staticClass:"fa fa-check-circle fa-3x text-success"})])
}
var staticRenderFns = []

export { render, staticRenderFns }